"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewProductsWidget = void 0;
var preview_products_widget_container_1 = require("./preview-products-widget.container");
Object.defineProperty(exports, "PreviewProductsWidget", { enumerable: true, get: function () { return preview_products_widget_container_1.PreviewProductsWidget; } });
